module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-conceptos/catalogo-conceptos.component.scss
// module id = ./src/app/components/catalogo-conceptos/catalogo-conceptos.component.scss
// module chunks = main